import { tokenDestinationCard } from "./TokenDestinationCard";

export const MicrosoftAdsDestinationCard = tokenDestinationCard({
  type: "microsoft_ads",
  // Never "Bing". Microsoft retired that brand for advertising, and a
  // merchant looking for "Bing" in the current UI will not find it.
  intro:
    "Server-side conversions to Microsoft Advertising, so conversions from Microsoft search still count when " +
    "the browser tag is blocked. Both IDs come from the UET section of your account: copy the Tag ID of the " +
    "tag your purchase goal uses, then open that same tag with the pencil icon and walk through Save and next, " +
    "Set up tagging, Use Conversions API, Copy token. No Use Conversions API option means Microsoft has not " +
    "enabled the API on your account yet, and their support can do it.",
  fields: [
    {
      key: "tagId",
      label: "UET tag ID",
      placeholder: "123456789",
      helpText: "Numbers only. Use the tag your purchase goal is attached to, not whichever one is first in the list.",
    },
    {
      key: "apiToken",
      label: "Conversions API token",
      secret: true,
      helpText: "Minted on one UET tag, and only valid for that tag. A token from another tag is rejected.",
    },
  ],
  testNote:
    "Two things to set up on Microsoft's side, or the conversions arrive and do nothing. On the token's tag, " +
    "create an Event goal with the action name purchase, set the revenue to vary per conversion, and turn " +
    "Enhanced conversions on. Then stop your browser purchase event from counting against the same goal, or " +
    "every sale is counted twice. Microsoft merges two reports of one purchase only when both carry the same " +
    "event ID, and a browser tag does not know Datacrow's. Test sends an event named datacrow_test with no " +
    "revenue on it, so pressing Test cannot add a conversion whatever your goals are set to.",
});
